import { isReactNative } from 'ui-builder';
import RoadmapPreviewLayoutWeb from './RoadmapPreviewLayout.web';
import RoadmapPreviewLayoutMobile from './RoadmapPreviewLayout.mobile';

const Layout = isReactNative()
  ? RoadmapPreviewLayoutMobile
  : RoadmapPreviewLayoutWeb;

export default Layout;
